import { createStore } from 'solid-js/store';
import { MODES, type ModeId } from '@domain/modes/modes';
import {
  loadActivity,
  recordAttempt,
  saveActivity,
  type ActivityMap,
} from '@domain/openings/activity';

function loadAll(): Record<ModeId, ActivityMap> {
  const out = {} as Record<ModeId, ActivityMap>;
  for (const mode of MODES) {
    out[mode.id] = loadActivity(mode.id);
  }
  return out;
}

export const [modeStore, setModeStore] = createStore({
  current: 'opening' as ModeId,
  activities: loadAll(),
});

export function setCurrentMode(id: ModeId): void {
  setModeStore('current', id);
}

export function recordModeAttempt(mode: ModeId, matched: boolean): void {
  const next = recordAttempt(modeStore.activities[mode], matched);
  setModeStore('activities', mode, next);
  saveActivity(next, mode);
}
